exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._24N77mDGihC8lEw-gSsC6r {\n  cursor: pointer;\n}\n\n/* Desktop size */\n@media (min-width: 768px) {\n\n  ._24N77mDGihC8lEw-gSsC6r {\n    max-width: 100%;\n  }\n}\n\n/* Mobile devices - excluding ipad*/\n@media (max-width: 767px) {\n\n  ._24N77mDGihC8lEw-gSsC6r {\n    max-width: 100%;\n  }\n}", ""]);

// Exports
exports.locals = {
	"videoEl": "_24N77mDGihC8lEw-gSsC6r"
};